import React from 'react'
import "../components/Navbar/Navbar.css"
const Loader = () => {
  return (
    <div className='Load'>
         <img src="../images/Diwali-Bomb.gif" alt="img"/>
    </div>
  )
}

export default Loader